import React from 'react';
import { Box } from '@mui/material';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import throttle from 'lodash/throttle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import toast from 'react-hot-toast';
import { useRecoilState } from 'recoil';
import SearchIcon from '@mui/icons-material/Search';
import { OrderPayload, SecondaryApprover } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import Select, { CssTextField } from 'pages/reference-implementation/components/select';
import { InputLabel } from 'pages/reference-implementation/components/input-label';
import { RIStyles } from 'pages/reference-implementation/Style';

const NonPrivilegedADGroupOwner = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [value, setValue] = React.useState(null);
    const [ccInputValue, setCCInputValue] = React.useState('-');
    const [searched, setSearched] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [secondApprover, setSecondaryApprover] = useRecoilState(SecondaryApprover);
    const [approverChanged, setApproverChanged] = React.useState(false);

    const adGroupOwnerApi = useMutation(() => axios.get(`${endPoints.riServices.COMMON.adGroupManager}?name=${ccInputValue}`));
    const adGroupOwnerPostApi = useMutation((payload) => axios.get(`${endPoints.riServices.COMMON.adGroupManager}?name=${payload}`));

    const setNonPrivilegedADGroupOwner = (nonPrivilegedADGroupOwner, nonPrivilegedADGroupOwnerDetails) => {
        if (
            nonPrivilegedADGroupOwner !== null &&
            nonPrivilegedADGroupOwnerDetails !== null &&
            nonPrivilegedADGroupOwnerDetails?.name !== secondApprover?.value?.name
        ) {
            setSecondaryApprover({
                selectedFieldFrom: { module: 'AccessMangement', subModule: 'NonPrivileged' },
                value: { groupOwner: nonPrivilegedADGroupOwner, groupOwnerDetails: nonPrivilegedADGroupOwnerDetails },
            });

            if (secondApprover?.value?.groupOwner && secondApprover?.value?.name !== nonPrivilegedADGroupOwnerDetails?.name) {
                toast.custom(
                    <Box
                        sx={{
                            display: 'flex',
                            background: '#FFFFFF',
                            color: (theme) => theme.palette.black,
                            minWidth: '300px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            padding: (theme) => theme.spacing(1),
                        }}
                    >
                        <ReportProblemIcon sx={{ color: '#F99C24', margin: (theme) => theme.spacing(1) }} />
                        {nonPrivilegedADGroupOwnerDetails?.name} will be considered as Second Approver
                    </Box>,
                    { duration: 5000 }
                );
            }
        }
        setOrder({
            ...order,
            nonPrivilegedADGroupOwner,
            nonPrivilegedADGroupOwnerDetails,
        });
    };
    // React.useEffect(() => {
    //     if (order?.nonPrivilegedADGroup === 'No' && order?.privilegedADGroup === 'No' && order?.privilegedADGroupOwner && !approverChanged) {
    //         if (!secondApprover?.value?.groupOwner) {
    //             setOrder({
    //                 ...order,
    //                 nonPrivilegedADGroupOwner: order?.privilegedADGroupOwner,
    //                 nonPrivilegedADGroupOwnerDetails: order?.privilegedADGroupOwnerDetails,
    //             });
    //         } else if (secondApprover?.value?.groupOwnerDetails?.name !== order?.privilegedADGroupOwnerDetails?.name) {
    //             setOrder({
    //                 ...order,
    //                 nonPrivilegedADGroupOwner: secondApprover?.value?.groupOwner,
    //                 nonPrivilegedADGroupOwnerDetails: secondApprover?.value?.groupOwnerDetails,
    //             });
    //         }
    //     }
    //     if (order?.nonPrivilegedADGroup === 'No' && order?.privilegedADGroup === 'No' && order?.nonPrivilegedADGroupOwner && secondApprover) {
    //         setOrder({
    //             ...order,
    //             nonPrivilegedADGroupOwner: secondApprover?.value?.groupOwner,
    //             nonPrivilegedADGroupOwnerDetails: secondApprover?.value?.groupOwnerDetails,
    //         });
    //     }
    //     if (
    //         order?.nonPrivilegedADGroup === 'No' &&
    //         order?.privilegedADGroup === 'No' &&
    //         !order?.privilegedADGroupOwner &&
    //         order?.nonPrivilegedADGroupOwner &&
    //         secondApprover &&
    //         order?.nonPrivilegedADGroupOwnerDetails?.name !== secondApprover?.value?.groupOwnerDetails?.name &&
    //         !approverChanged
    //     ) {
    //         setOrder({
    //             ...order,
    //             nonPrivilegedADGroupOwner: secondApprover?.value?.groupOwner,
    //             nonPrivilegedADGroupOwnerDetails: secondApprover?.value?.groupOwnerDetails,
    //         });
    //     }
    // }, [order?.nonPrivilegedADGroup, order?.privilegedADGroup, order?.privilegedADGroupOwner, secondApprover]);
    const resetOptions = () => {
        setOptions([]);
        setNonPrivilegedADGroupOwner(null, null);
    };
    const fetch = React.useMemo(
        () =>
            throttle(() => {
                adGroupOwnerApi.mutate();
            }, 1000),
        []
    );
    const handleSearch = () => {
        // istanbul ignore if
        if (ccInputValue === '') {
            resetOptions();
        }
        // istanbul ignore else
        if (ccInputValue !== '' && ccInputValue.length > 2) {
            setSearched(true);
            fetch();
        }
    };

    React.useEffect(() => {
        if (adGroupOwnerPostApi?.data?.data) {
            const combinedValue = adGroupOwnerPostApi?.data?.data?.map((app) => ({
                label: `${app.gpid} - ${app.name}`,
                gpid: `${app.gpid}`,
                name: `${app.name}`,
                email: `${app.email}`,
            }));
            setOptions(combinedValue);
        }
    }, [adGroupOwnerPostApi?.data?.data]);

    React.useEffect(() => {
        if (adGroupOwnerApi?.data?.data) {
            const combinedValue = adGroupOwnerApi?.data?.data?.map((app) => ({
                label: `${app.gpid} - ${app.name}`,
                gpid: `${app.gpid}`,
                name: `${app.name}`,
                email: `${app.email}`,
            }));
            setOptions(combinedValue);
        }
    }, [adGroupOwnerApi?.data?.data]);

    React.useEffect(() => {
        if (value === null) {
            // resetOptions();
        } else {
            setOptions(options?.filter((z) => z?.gpid === value?.gpid));
            setNonPrivilegedADGroupOwner(value?.label, value);
        }
    }, [value]);

    const isExistsInOptions = (appownerValue) => options.find((option) => appownerValue === option.name);

    React.useEffect(() => {
        if (
            options &&
            options?.length === 1 &&
            (order?.nonPrivilegedADGroupOwnerDetails || secondApprover?.value?.groupOwner) &&
            order?.nonPrivilegedADGroupOwnerDetails?.name !== secondApprover?.value?.groupOwnerDetails?.name
        ) {
            setOrder({ ...order, nonPrivilegedADGroupOwner: options?.[0].label, nonPrivilegedADGroupOwnerDetails: options?.[0] });
        }
        if (options && options?.length > 1 && order?.nonPrivilegedADGroupOwnerDetails && !order?.nonPrivilegedADGroupOwner) {
            const adGroupObj = isExistsInOptions(order?.nonPrivilegedADGroupOwnerDetails?.name);
            setOrder({ ...order, nonPrivilegedADGroupOwner: adGroupObj?.label, nonPrivilegedADGroupOwnerDetails: adGroupObj });
        }
    }, [options]);

    React.useEffect(() => {
        if (
            !order?.nonPrivilegedADGroupOwner &&
            order?.nonPrivilegedADGroupOwnerDetails &&
            order?.appOwner &&
            order?.businessContact &&
            !secondApprover?.value?.groupOwner
        ) {
            adGroupOwnerPostApi.mutate(order?.nonPrivilegedADGroupOwnerDetails?.name);
        }
        if (
            !order?.nonPrivilegedADGroupOwner &&
            !order?.nonPrivilegedADGroupOwnerDetails &&
            // order?.appOwner &&
            // order?.businessContact &&
            secondApprover?.value?.groupOwner &&
            !approverChanged
        ) {
            adGroupOwnerPostApi.mutate(secondApprover?.value?.groupOwnerDetails?.name);
        }
        if (
            order?.nonPrivilegedADGroupOwner &&
            order?.nonPrivilegedADGroupOwnerDetails &&
            secondApprover?.value?.groupOwnerDetails &&
            secondApprover?.value?.groupOwnerDetails?.name !== order?.nonPrivilegedADGroupOwnerDetails?.name &&
            !approverChanged
        ) {
            adGroupOwnerPostApi.mutate(secondApprover?.value?.groupOwnerDetails?.name);
        }
    }, [order?.nonPrivilegedADGroupOwner, order?.nonPrivilegedADGroupOwnerDetails, order?.appOwner, order?.businessContact, secondApprover, approverChanged]);

    React.useEffect(() => {
        if (!order?.nonPrivilegedADGroupOwner && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.nonPrivilegedADGroupOwner, order?.isTouched]);

    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.nonPrivilegedADGroupOwner) || isTouched) {
            return 'validate';
        }
        return '';
    };
    const getNoOptionText = () => {
        let text = '';
        if (searched === false) {
            text = 'Type & press enter to search by GPID, Firstname and Lastname';
        } else if (options?.length === 0) {
            text = 'No results found';
        }
        return text;
    };

    React.useEffect(() => {
        if (order?.nonPrivilegedADGroup === 'No' && order?.myCertADGroup === 'No' && order?.myCertADGroupOwner) {
            setOrder({
                ...order,
                nonPrivilegedADGroupOwner: order?.myCertADGroupOwner,
                nonPrivilegedADGroupOwnerDetails: order?.myCertADGroupOwnerDetails,
            });
        }
    }, [order?.nonPrivilegedADGroup, order?.myCertADGroup, order?.myCertADGroupOwner]);

    return (
        <>
            <Box display="flex" alignItems="center" gap={1}>
                <Select
                    dataTestId="non-privileged-ad-group-owner-search"
                    key="AD Group Owner"
                    size="small"
                    noOptionsText={getNoOptionText()}
                    loading={adGroupOwnerApi?.isLoading}
                    value={order?.nonPrivilegedADGroupOwner || null}
                    onInputChange={(event, newInputValue) => {
                        if (newInputValue) setCCInputValue(newInputValue?.includes('-') ? newInputValue?.split('-')?.pop()?.trim() : newInputValue);
                        if (secondApprover?.value?.groupOwnerDetails?.name && order?.privilegedADGroupOwnerDetails?.name) {
                            setApproverChanged(true);
                        }
                    }}
                    disabled={
                        order?.environment?.toLowerCase() !== 'production' &&
                        order?.isExternal === 'Yes' &&
                        order?.myCertADGroup === 'No' &&
                        order?.nonPrivilegedADGroup === 'No'
                    }
                    className={validateInput()}
                    onChange={(event, newValue) => {
                        if (secondApprover?.value?.groupOwnerDetails?.name && order?.privilegedADGroupOwnerDetails?.name) {
                            setApproverChanged(true);
                        }
                        // istanbul ignore else
                        if (typeof newValue === 'string') {
                            setValue({
                                label: newValue,
                            });
                        } else if (newValue && newValue.inputValue) {
                            // Create a ccccccnew value from the user input
                            setValue({
                                label: newValue.inputValue,
                            });
                        } else {
                            setValue(newValue);
                        }
                        if (!secondApprover?.value?.groupOwner && newValue?.name) {
                            setApproverChanged(true);
                        } else if (secondApprover?.value?.groupOwner && value?.name !== secondApprover?.value?.groupOwnerDetails?.name) {
                            setApproverChanged(true);
                        }
                    }}
                    isRequired={isTouched}
                    //    filterOptions={filterOptions}

                    filterOptions={(optionValues, params) => {
                        // eslint-disable-next-line no-underscore-dangle
                        const _results = [];
                        // eslint-disable-next-line no-plusplus
                        for (let i = 0; i < optionValues.length; i++) {
                            // eslint-disable-next-line no-restricted-syntax
                            for (const key in optionValues[i]) {
                                if (optionValues[i][key] !== null && typeof optionValues[i][key] !== 'boolean' && typeof optionValues[i][key] !== 'number') {
                                    if (optionValues[i][key].toLowerCase().includes(params?.inputValue.toLowerCase())) {
                                        _results.push(optionValues[i]);
                                    }
                                }
                            }
                        }
                        return [...new Set(_results)];
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable
                    id="free-solo-with-text-demo"
                    sx={{ width: '100%' }}
                    options={options}
                    isOptionEqualToValue={(option, value1) => option?.label === value1}
                    renderOption={(props, option) => (
                        <li {...props} key={option.gpid}>
                            {option.label}
                        </li>
                    )}
                    onBlur={() => {
                        if (!value || !order?.nonPrivilegedADGroupOwner) {
                            setApproverChanged(false);
                            setSearched(false);
                            setOptions([]);
                        }
                    }}
                    onKeyUp={(event) => {
                        if (event.key === 'Enter') {
                            setSearched(true);
                            handleSearch();
                        }
                        if ((event.key === 'Backspace' || event.key === 'Delete') && (!event.target.value || event.target.value === '')) {
                            setSearched(false);
                            resetOptions();
                        }
                    }}
                    renderInput={(params) => (
                        <CssTextField
                            size="large"
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...params}
                            label={<InputLabel label="AD Group Owner" isRequired />}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        <SearchIcon
                                            sx={RIStyles?.form?.searchIcon}
                                            onClick={() => {
                                                setSearched(true);
                                                handleSearch();
                                            }}
                                            data-testid="search-btn"
                                        />
                                    </>
                                ),
                            }}
                            fullWidth
                        />
                    )}
                />
            </Box>
        </>
    );
};

export default React.memo(NonPrivilegedADGroupOwner);
